import { useEffect, useState } from 'react';

export type OrientationType = 'portrait' | 'landscape';

function getInitialOrientation(): OrientationType {
    if (window.screen?.orientation?.type) {
        return window.screen.orientation.type.split('-')[0] as OrientationType;
    }
    return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
}

function useScreenOrientation(): OrientationType {
    const [orientation, setOrientation] = useState<OrientationType>(getInitialOrientation);

    useEffect(() => {
        const handleOrientationChange = (): void => {
            if (window.screen?.orientation?.type) {
                const orientationType = window.screen.orientation.type.split('-')[0] as OrientationType;
                setOrientation(orientationType);
            } else {
                setOrientation(window.innerWidth > window.innerHeight ? 'landscape' : 'portrait');
            }
        };

        window.addEventListener('resize', handleOrientationChange);

        return () => {
            window.removeEventListener('resize', handleOrientationChange);
        };
    }, []);

    return orientation;
}

export default useScreenOrientation;
